'use client';

import Link from 'next/link';

import { Flex, Heading } from '@chakra-ui/react';

import { Button } from 'ui';

interface DashboardPageHeaderProps {
  headingColor: string;
  title: string;
  buttonLabel: string;
  href: string;
  isStickyBtn?: boolean;
}

const DashboardPageHeader = ({
  headingColor,
  title,
  buttonLabel,
  href,
  isStickyBtn = false
}: DashboardPageHeaderProps) => (
  <Flex
    flexDirection={{ base: 'column-reverse', sm: 'row' }}
    justifyContent='space-between'
    alignItems='center'
    gap='36px'
    mb={['30px', '25px', '20px']}
  >
    <Heading
      fontSize={{ base: '22px', sm: '24px', md: '28px' }}
      fontWeight={600}
      color={headingColor}
      textAlign={{
        base: 'center',
        sm: 'start'
      }}
    >
      {title}
    </Heading>

    <Button
      display={{
        base: isStickyBtn ? 'none' : 'inherit',
        md: 'inherit'
      }}
      as={Link}
      href={href}
      variant='solid'
      colorScheme='secondaryLight'
      width={{ base: '100%', sm: '209px' }}
      height='45px'
      fontSize={{ base: 15, sm: 14 }}
      lineHeight={1}
    >
      {buttonLabel}
    </Button>
  </Flex>
);

export default DashboardPageHeader;
